export default __webpack_public_path__ + "static/Sydney-3d5a61e49ba44e917fdb97fea9b08169.webp";